<template>
  <div class="hall-probe-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>U_h = k · I · B / d | 磁感应强度测量$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Sensor Head -->
          <rect x="150" y="80" width="100" height="80" fill="#222" stroke="#888" />
          <path d="M 150,80 L 100,60" stroke="#888" stroke-width="2" /> <!-- Cable -->
          
          <!-- Internal Semiconductors -->
          <rect x="160" y="90" width="80" height="60" fill="rgba(46, 213, 115, 0.2)" stroke="#2ed573" />
          
          <!-- Magnetic Field B (Moving into page) -->
          <g v-if="bField > 0" opacity="0.6">
             <g v-for="i in 5" :key="i">
                <circle v-for="j in 3" :key="j" :cx="165 + i*15" :cy="95 + j*15" r="3" fill="none" stroke="#ffd700" />
                <path v-for="j in 3" :key="'x'+j" :d="`M ${162 + i*15},${92 + j*15} L ${168 + i*15},${98 + j*15} M ${168 + i*15},${92 + j*15} L ${162 + i*15},${98 + j*15}`" stroke="#ffd700" stroke-width="1" />
             </g>
          </g>

          <!-- Hall Charge separation -->
          <g v-if="bField > 0">
             <circle v-for="n in 5" :key="'p'+n" :cx="165 + n*12" cy="95" r="3" fill="#ff4757" /> <!-- Positives -->
             <circle v-for="n in 5" :key="'m'+n" :cx="165 + n*12" cy="145" r="3" fill="#00d2ff" /> <!-- Negatives -->
          </g>

          <!-- Voltmeter Display -->
          <rect x="280" y="40" width="80" height="40" fill="#111" stroke="#2ed573" />
          <text x="290" y="65" fill="#2ed573" font-family="monospace">{{ (bField * 1.5).toFixed(1) }} mT</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>测量反馈: {{ bField > 0 ? '检测到横向磁场' : '背景场为零' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节外部磁场 B</label>
             <el-slider v-model="bField" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>霍尔探头是基于**霍尔效应**制成的磁场测量传感器。当恒定电流流过半导体薄片时，如果存在垂直于表面的磁场，载流子会受到洛伦兹力而向一侧偏转，在薄片两侧形成电势差。通过测量这个**霍尔电压**，我们可以精确推算出磁感应强度 B。它体积小、反应灵敏，是工业和科学实验中测量磁场最常用的手段。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HallProbeViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      bField: 40
    }
  }
}
</script>

<style scoped lang="scss">
.hall-probe-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(46, 213, 115, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
